/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from 'react'
import { Helmet } from 'react-helmet'
import parse from 'html-react-parser'
import { graphql, useStaticQuery } from 'gatsby'

const Seo = ({ seo, title }) => {
  const data = useStaticQuery(graphql`
    query SiteInfoQuery {
      wp {
        seo {
          schema {
            siteUrl
            logo {
              sourceUrl
              mediaItemUrl
            }
          }
        }
      }
    }
  `)
  const {
    wp: {
      seo: { schema },
    },
  } = data
  return (
    <Helmet title={seo.title}>
      {parse(seo?.fullHead || ``)}
      <script type="application/ld+json">
        {`[{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org","@type":"SiteNavigationElement","@id":"https://www.dmautoleasing.com/#Main Menu","name":"Home","url":"https://www.dmautoleasing.com/"}]},{"@context": "https://schema.org","@type": "Organization", "url": "${schema.siteUrl}", "logo": "${schema.logo?.sourceUrl}"}, {"@context": "https://schema.org","@type":"Review","@id":"https://www.dmautoleasing.com/#Review","itemReviewed":{"@type":"LocalBusiness","image":[]},"name":"D&M Auto Leasing","author":{"@type":"Person","name":"Darren Hasley"}}]`}
      </script>
      <script type="application/ld+json">{`${seo?.schema.raw}`}</script>
    </Helmet>
  )
}

export default Seo
